import { memo } from 'react'
import { useAccountContext } from 'src/components/account/context'
import { InView } from 'react-intersection-observer'
import { useAddressContext } from 'src/components/checkout/steps/shipping/context/address-context'
import { LocationOnIcon } from 'src/components/Icons/LocationOnIcon'
import { useGlobalContext } from 'src/components/contexts/GlobalContext'
import { PDP_FIRST_FOLD_REVAMP_EXPERIMENT_ID } from 'src/components/common/StatsigExposure/StatsigExposure'
import { Statsig } from 'src/sdk/statsig'
import { PAGE_TYPE_MAP } from 'src/hooks/usePageType'

import { PostalCodeSkeleton } from './PostalCodeSkeleton'
import { PostalCodeTriggerContent } from './PostalCodeTriggerContent'
import { usePostalCodeModal } from '../../Hooks/usePostalCodeModal'
import { PostalCodeModal } from '../Modals/PostalCodeModal'
import { usePostalCodeViewedEvent } from '../../Hooks/usePostalCodeViewedEvent'

const STYLES = {
  loadingWrapper: 'py-[7px] px-4 bg-restructure-background-neutral-3',
  loadingSkeleton: 'w-[170px] h-[20px]',
  triggerWrapper:
    'flex justify-start items-center gap-1.5 pt-[9px] pb-2.5 px-4 bg-restructure-background-neutral-3',
  label:
    'text-font-size-1 leading-[15px] font-medium text-restructure-primary whitespace-nowrap',
  button:
    'text-primaryBlue text-font-size-1 leading-[15px] font-medium underline',
} as const

export const PostalCodeInputMobile = memo(function PostalCodeInputMobile() {
  const { showModal, setShowModal, ref } = usePostalCodeModal()
  const { postalCode } = useAddressContext()
  const { isLoading } = useAccountContext()
  const { pageData } = useGlobalContext()
  const onVisibilityChange = usePostalCodeViewedEvent()
  const isPdpFirstFoldRevampEnabled = Statsig.useStatsigFeatureGateValue(
    PDP_FIRST_FOLD_REVAMP_EXPERIMENT_ID
  )

  const isPdpPage = pageData.currentPageType === PAGE_TYPE_MAP.pdp
  const shouldHideOnPdpFirstFoldTreatment =
    isPdpPage && isPdpFirstFoldRevampEnabled

  if (shouldHideOnPdpFirstFoldTreatment) {
    return null
  }

  if (isLoading) {
    return (
      <div className={STYLES.loadingWrapper}>
        <div className={STYLES.loadingSkeleton}>
          <PostalCodeSkeleton width={170} height={20} />
        </div>
      </div>
    )
  }

  return (
    <div ref={ref}>
      <div className={STYLES.triggerWrapper}>
        <LocationOnIcon />
        <PostalCodeTriggerContent
          postalCode={postalCode}
          onOpenModal={() => setShowModal(true)}
          labelClassName={STYLES.label}
          buttonClassName={STYLES.button}
        />
      </div>
      <InView onChange={onVisibilityChange} triggerOnce>
        <PostalCodeModal showModal={showModal} setShowModal={setShowModal} />
      </InView>
    </div>
  )
})
